export default __webpack_public_path__ + "static/media/tokenImageAprobank.a55e0580.svg";